var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeams(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "16px",
    height: "16px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5C6BC0"
    },
    cx: 41.5,
    cy: 16.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6BC0"
    },
    d: "M4,40l23,4V4L4,8V40z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "21,16.27 21,19 17.01,19.18 16.99,31.04 14.01,30.95 14.01,19.29 10,19.45 10,16.94 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6BC0"
    },
    d: "M36,14c0,2.21-1.79,4-4,4c-1.2,0-2.27-0.53-3-1.36v-5.28c0.73-0.83,1.8-1.36,3-1.36  C34.21,10,36,11.79,36,14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6BC0"
    },
    d: "M38,23v11c0,0,1.567,0,3.5,0c1.762,0,3.205-1.306,3.45-3H45v-8H38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6BC0"
    },
    d: "M29,20v17c0,0,1.567,0,3.5,0c1.762,0,3.205-1.306,3.45-3H36V20H29z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.1d30d840553e2d8f86ff111d36126fc8.svg";
export { ForwardRef as ReactComponent };